// src/pages/ResetPassword.jsx
import React, { useState} from "react";
import {  useNavigate,useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import "bootstrap/dist/css/bootstrap.min.css";
import "react-toastify/dist/ReactToastify.css";

export default function ResetPassword() {
  const navigate = useNavigate();
  const location =useLocation()
  
  const { email } = location.state 

  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);

  // Basic client-side validation
  const isValid =
   
    password === confirmPassword;

  

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!isValid) {
      toast.error("Passwords must match and be at least 8 characters long.");
      return;
    }

    setLoading(true);
    try {
      const res = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/admin/reset-password`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ email, password }),
        }
      );

      const data = await res.json();

      if (!res.ok) {
        toast.error(data.message || "Failed to reset password.");
        return;
      }

      toast.success("Password reset successfully! You can now log in.");
      navigate("/login")
    } catch (err) {
      toast.error("Network error. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  // Success Screen


  // Main Reset Form
  return (
    <div
      className="d-flex justify-content-center align-items-center"
      style={{ minHeight: "100vh"}}
    >
      <div
        className="card shadow-lg rounded-4 p-4 p-md-5"
        style={{
          maxWidth: "480px",
          width: "100%",
          background: "#fff",
          border: "none",
        }}
      >
        <div className="text-center mb-4">
          <h3 className="fw-bold" style={{ color: "#4c1d95" }}>
            Set New Password
          </h3>
          <p className="text-muted">
            Create a strong password.
          </p>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <label htmlFor="password" className="form-label fw-semibold" style={{ color: "#4c1d95" }}>
              New Password
            </label>
            <input
              type="password"
              className="form-control rounded-3"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              minLength="8"
              placeholder="Enter new password"
              style={{ padding: "12px 16px", border: "1px solid #d1d5db" }}
            />
          </div>

          <div className="mb-4">
            <label htmlFor="confirmPassword" className="form-label fw-semibold" style={{ color: "#4c1d95" }}>
              Confirm New Password
            </label>
            <input
              type="password"
              className="form-control rounded-3"
              id="confirmPassword"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
              minLength="8"
              placeholder="Re-enter new password"
              style={{ padding: "12px 16px", border: "1px solid #d1d5db" }}
            />
            {password && confirmPassword && password !== confirmPassword && (
              <small className="text-danger mt-1 d-block">
                Passwords do not match
              </small>
            )}
          </div>

          <button
            type="submit"
            disabled={loading || !isValid}
            className="btn w-100 text-white fw-semibold rounded-3 py-3"
            style={{
              background: "linear-gradient(90deg, #4c1d95, #6d28d9)",
              boxShadow: "0 4px 12px rgba(76, 29, 149, 0.3)",
              opacity: loading || !isValid ? 0.7 : 1,
            }}
          >
            {loading ? "Updating Password..." : "Reset Password"}
          </button>
        </form>

   
      </div>
    </div>
  );
}